import { logger } from '@accedo/logger';
import { config, focusCache } from '##/services/store/store';
import tenApiService from '##/services/tenApi';
import { BVOD_N10_TOKEN_KEY } from '##/utils';
import { ActivationResponse } from '../tenApi/auth';
import { FMS_RESPONSE, FMS_RESPONSE_TIMESTAMP } from '../tenApi/fms';

export const refreshOnTokenExpiry = async (): Promise<void> => {
  const token = {
    refreshToken: localStorage.getItem('refreshToken'),
    alternativeToken: localStorage.getItem('altToken'),
  };
  const newToken = await tenApiService.auth.getRefreshToken(token);
  const newUser = await tenApiService.auth.getUserInfoOnRefresh(
    newToken.alternativeToken,
  );

  localStorage.setItem('altToken', newToken.alternativeToken);
  localStorage.setItem('refreshToken', newToken.refreshToken);
  config.$set({ user: { ...newUser, jwt: { ...newToken } } });
};

export const logout = (): void => {
  config.$set({ user: undefined, myShowsIds: undefined });
  localStorage.removeItem(FMS_RESPONSE);
  localStorage.removeItem(FMS_RESPONSE_TIMESTAMP);
  localStorage.removeItem('altToken');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem(BVOD_N10_TOKEN_KEY);
  focusCache.home.$clear();
};

export const isLoggedIn = (): boolean => {
  const isLoggedin = Boolean(localStorage.getItem('refreshToken'));
  if (!isLoggedin) {
    return false;
  }
  return true;
};

export const getUserInfo = (): ActivationResponse | null => {
  if (!config.$get().user) {
    return null;
  }
  return config.$get().user || null;
};

export const getAccessToken = (): string | null => {
  if (!config.$get().user?.jwt) {
    return null;
  }

  const { accessToken } = config.$get().user?.jwt;
  return accessToken || null;
};

export const getAlternativeToken = (): string | null => {
  if (!config.$get().user?.jwt) {
    return null;
  }
  const { alternativeToken } = config.$get().user.jwt;
  return alternativeToken;
};

export const checkAuthentication = async (): Promise<void> => {
  const refreshTokenExists = isLoggedIn();
  const initialToken = {
    refreshToken: localStorage.getItem('refreshToken'),
    alternativeToken: localStorage.getItem('altToken'),
  };
  if (!refreshTokenExists) {
    return;
  }

  if (refreshTokenExists && !config.$get().user?.jwt) {
    let newToken = null;
    try {
      newToken = await tenApiService.auth.getRefreshToken(initialToken);
    } catch (err) {
      logout();
      logger.error('Network error refreshing token', err);
      throw err;
    }
    if (newToken) {
      const newUser = await tenApiService.auth.getUserInfoOnRefresh(
        newToken.alternativeToken,
      );

      localStorage.setItem('altToken', newToken.alternativeToken);
      localStorage.setItem('refreshToken', newToken.refreshToken);
      config.$set({ user: { ...newUser, jwt: { ...newToken } } });
    }
  }
};
